export default {
  container: "1600px",
}
